const modalTypes = {
  ADD_MODAL: "ADD_MODAL",
  TOGGLE_2024: "TOGGLE_2024",
};

export default modalTypes;
